/**
 * 活动分配模式
 * 立即分配：申购不支持此选项。选择后完成支付则立即得到对应数量的项目代币
 * 结束后分配：项目周期内不发放代币，项目结束后两小时内进行发放
 * 锁仓分配：需设定解锁日期；项目结束后两小时内发放代币，解锁日期前代币处于冻结状态，不可进行交易，提币，划转等操作
 */
export const INCUBATOR_DISTRIBUTION_MODEL_ENUM = [
    {name: "立即分配", code: 0, value: "IMMEDIATE_DISTRIBUTION"},
    {name: "结束后分配", code: 1, value: "COMPLETION_DISTRIBUTION"},
    {name: "锁仓分配", code: 2, value: "LOCK_DISTRIBUTION"}
]

/**
 * 活动模式
 */
export const INCUBATOR_TYPE_ENUM = [
    {name: "秒杀模式", code: 0, value: "SECKILL"},
    {name: "团购模式", code: 1, value: "GROUPBUYING"},
    {name: "投入模式", code: 2, value: "INVESTMENT"}
]

/**
 * 活动状态
 */
export const INCUBATOR_STATUS_ENUM = [
    {label: '未上线', code: "UNONLINE", value: 0},
    {label: '未开始', code: "UNSTART", value: 1},
    {label: '进行中', code: "UNDERWAY", value: 2},
    {label: '已结束(等待放币)', code: "FINISHED", value: 3},
    {label: '核算中', code: "CHECKING", value: 4},
    {label: '核算完', code: "CHECKED", value: 5},
    {label: '已完成', code: "COMPLETE", value: 6}
]

/**
 * 活动订单状态
 */
export const INCUBATOR_ORDER_STATUS_ENUM = [
    {label: '未检查', code: "UNCHECKED", value: 0},
    {label: '已检查', code: "CHECKED", value: 1},
    {label: '可转账', code: "CANTRANS", value: 2},
    {label: '转账中', code: "TRANSING", value: 3},
    {label: '成功', code: "SUCCEED", value: 4},
    {label: '失败', code: "FAILED", value: 5}
]

/**
 * 列表排序方式
 */
export const SORT_TYPE = [
    {label: '展示时间', value: 1},
    {label: '开始时间', value: 2},
    {label: '结束时间', value: 3},
    {label: '创建时间', value: 4}
]

/**
 * 持仓类型
 */
export const INCUBATOR_POSITION_TYPE_ENUM = [
    {label: '日均持仓', code: 0, value: "AVERAGE_DAILY_POSITION"},
    {label: '每日持仓', code: 1, value: "DAILY_POSITION"},
    {label: '当前持仓', code: 2, value: "CURRENT_POSITION"}
]

/**
 * 交易额类型
 */
export const INCUBATOR_TURNOVER_TYPE_ENUM = [
    {label: '成交额', code: 0, value: "TURNOVER"},
    {label: '总手续费', code: 1, value: "TOTAL_HANDLING_FEE"}
]

/**
 * 表单回答方式
 */
export const FORM_ANSWER_TYPE = [
    {label: '填空', code: 0, value: "FILL_BLANK"},
    {label: '文本', code: 1, value: "TEXT"},
    {label: '单选', code: 2, value: "RADIO"},
    {label: '多选', code: 3, value: "CHECKBOX"},
    {label: '手机', code: 4, value: "PHONE"},
    {label: '邮箱', code: 5, value: "EMAIL"}
]